/**
 * Created by danielg on 9/6/15.
 */
define(function (require) {
    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var BaseController = require('web-agent-assets-js/BaseController');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');

    /////////////////////////////////// PRIVATE VARIABLES ///////////////////////////////////
    var _queueModel;
    var _callbacks;
    var _logger;

    /////////////////////////////////// INITIALIZATION ///////////////////////////////////
    var QueueMessagingAdapter = BaseController.extend(function QueueMessagingAdapter(options) {
        _logger = this.logger || WebAgentLogger.getLogger(this.applicationType);
        if (options) {
            _setModel(options.model);
            _setCallbacks(options);
        }
        if (_queueModel) {
            // Set binds here
            if (lpTag.WebAgent.logicController.hasMessagingFeature()) {
                _setAutoAccept.call(this, lpTag.WebAgent.logicController.useAutoAcceptForMessaging());
                _queueModel.bind('amsService.socketState', _handleAmsConnectionStatusChanged, this);
            }
        }
    });

    /////////////////////////////////// PUBLIC VARIABLES ///////////////////////////////////
    QueueMessagingAdapter.prototype.applicationType = 'QueueMessagingAdapter';
    QueueMessagingAdapter.prototype.ringingCount = 0;
    QueueMessagingAdapter.prototype.maxChatsReached = false;
    QueueMessagingAdapter.prototype.isConnected = false;
    QueueMessagingAdapter.prototype.isAutoAcceptEnabled = false;
    QueueMessagingAdapter.prototype.isTimerEnabled = false;

    /////////////////////////////////// PUBLIC METHODS ///////////////////////////////////
    /**
     * Returns true if there are chats in the queue and the service is connected and max chats is not reached
     * @returns {boolean} True if there are chats in the queue and the service is connected and max chats is not reached
     */
    QueueMessagingAdapter.prototype.canAcceptChat = function () {
        return this.hasChatsInQueue() && !this.maxChatsReached;
    };

    /**
     * Returns true if there are chats in the queue and the service is connected
     * @returns {boolean} True if there are chats in the queue and the service is connected
     */
    QueueMessagingAdapter.prototype.hasChatsInQueue = function () {
        return this.ringingCount > 0 && this.isConnected;
    };

    /**
     * Accepts the first chat in the queue, if there are chats in the queue
     */
    QueueMessagingAdapter.prototype.acceptChat = function () {
        if (this.canAcceptChat()) {
            var that = this;
            var request = {
                success: function (data) {
                    _callAcceptSuccessCallback.call(that, data);
                    that = null;
                },
                error: function (data) {
                    that.logger.error(data && data.error ? data.error.message : "Error in accept chat.", "acceptChat");
                    that.logger.graph({name: 'acceptChatError'});
                    that = null;
                    _callAcceptErrorCallback();
                },
                context: this
            };
            lpTag.WebAgent.amsRingService.takeConversation(request);
        }
    };

    /////////////////////////////////// PRIVATE METHODS ///////////////////////////////////

    /**
     * Handles changes in the AMS connection state
     */
    function _handleAmsConnectionStatusChanged () {
        var isAmsConnected = lpTag.WebAgent.logicController.isAmsConnectionStatusActive();
        if (isAmsConnected !== this.isConnected) {
            this.isConnected = !!isAmsConnected;
            _callIsConnectedCallback(isAmsConnected);
        }
        if (isAmsConnected) {
            this.connectionStateRenderRequired = true;
            _bindRingingCount.call(this);
        } else {
            _unbindRingingCount.call(this);
        }
    }

    /**
     * Binds to the ringing count
     */
     function _bindRingingCount() {
        _queueModel.bind(lpAMSController.MODEL_PATHS.connectionsListModelLocations.openConversations,
            _updateRingingCount, this);
    }

    /**
     * Unbinds from the ringing count
     */
    function _unbindRingingCount() {
        _queueModel.unbind(lpAMSController.MODEL_PATHS.connectionsListModelLocations.openConversations,
            _updateRingingCount, this);
    }

    /**
     * Updates the ringing count
     * @param event Contains the new value of the ringing count
     */
    function _updateRingingCount(event) {
        //If the agent is not online, send a reject rings to the server.
        var newRingingCount = (event && event.newValue) || 0;
        if (lpTag.WebAgent.logicController.getChatAvailability() === "Online") {
            if (newRingingCount && this.isAutoAcceptEnabled ||
                this.ringingCount !== newRingingCount) {
                if (this.ringingCount !== newRingingCount) {
                    this.ringingCount = newRingingCount;
                    _callCountChangeCallback(newRingingCount);
                }
                if (this.hasChatsInQueue()) {
                    _autoAcceptChat.call(this);
                }
            }
        } else {
            if (this.ringingCount !== newRingingCount) {
                lpTag.WebAgent.amsRingService.rejectAllRings();
                this.ringingCount = 0;
                _callCountChangeCallback(0);
            }
        }
    }

    /**
     * Auto accepts a chat if there are chats in the queue and auto accept is enabled
     */
    function _autoAcceptChat () {
        if (this.isAutoAcceptEnabled && this.hasChatsInQueue()) {
            _callAutoAcceptingCallback();
            this.acceptChat();
        }
    }

    /**
     * Sets isAutoAcceptEnabled to the given value, and acts accordingly
     * @param isAutoAcceptEnabled {boolean} The new value
     * @private
     */
    function _setAutoAccept(isAutoAcceptEnabled) {
        if (this.isAutoAcceptEnabled !== isAutoAcceptEnabled) {
            this.isAutoAcceptEnabled = isAutoAcceptEnabled;
        }
        _autoAcceptChat.call(this);
    }

    /**
     * Sets the model
     * @param model - the model
     * @private
     */
    function _setModel(model) {
        if (model) {
            _queueModel = model;
        }
    }

    /**
     * Sets the callbacks
     * @param callbacksObj - the callbacks
     * @private
     */
    function _setCallbacks(callbacksObj) {
        if (callbacksObj) {
            _callbacks = callbacksObj;
        }
    }

    /**
     * Calls the isConnected callback if it exists
     * @param isConnected - The isConnected value to pass on to the callback
     * @private
     */
    function _callIsConnectedCallback(isConnected) {
        if (_callbacks && _callbacks.isConnected) {
            _callbacks.isConnected.call(_callbacks.context, isConnected);
        }
    }

    /**
     * Calls the countChange callback if it exists
     * @param newCount - The newCount value to pass to the callback
     * @private
     */
    function _callCountChangeCallback(newCount) {
        if (_callbacks && _callbacks.countChange) {
            _callbacks.countChange.call(_callbacks.context, newCount);
        }
    }

    /**
     * Calls the autoAccepting callback if it exists
     * @private
     */
    function _callAutoAcceptingCallback() {
        if (_callbacks && _callbacks.autoAccepting) {
            _callbacks.autoAccepting.call(_callbacks.context);
        }
    }

    /**
     * Calls the acceptSuccess callback if it exists
     * @param data - The data from the ring service containing the conversation ID and the consumer ID
     * @private
     */
    function _callAcceptSuccessCallback(data) {
        if (_callbacks && _callbacks.acceptSuccess) {
            var toSend = {
                isAsyncMessaging: true,
                isAutoAccepted: this.isAutoAcceptEnabled
            };
            if (data) {
                if (data.conversationId) {
                    toSend.chatId = data.conversationId;
                }
                if (data.consumerId) {
                    toSend.visitorId = data.consumerId;
                }
            }
            _callbacks.acceptSuccess.call(_callbacks.context, toSend);
        }
    }

    /**
     * Calls the acceptError callback if it exists
     * @private
     */
    function _callAcceptErrorCallback() {
        if (_callbacks && _callbacks.acceptError) {
            _callbacks.acceptError.call(_callbacks.context);
        }
    }

    return QueueMessagingAdapter;

});
